import styled from 'styled-components';

export const Strong = styled.strong`
  color: ${({ theme }) => theme.colors.blackboard.main};
`;
